'use client';
import dynamic from 'next/dynamic';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import SeoServices from '@/components/technologies/seo-services';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import HireProcess from '@/components/technologies/hire-process';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import ContetImageSection from '@/components/common/content-image';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Looking to maximize organic revenues beyond borders?"
                alt="hero image"
                title="hero image"
                width={589}
                height={550}
                path={'seo-hero'}
                bgPath={'hero-bg-grunge'}
            >
                SEO Services
            </TechHeroApp>
            <DefaultBreadcrumb parentPage="Services" isParent={true} currentPage="SEO Services" />
            <ContetImageSection title="Win the battle of search engines with the most trusted and renowned SEO Company">
                <>
                    <p className="fw-400 text-secondary fs-md  mb-0">
                        Moweb leads the charge to increase your website search traffic results. Are you facing trouble getting
                        velocity in certain keyword phrases? With Moweb, you can get advice from the real-time team of SEO experts
                        who analyze each and every corner of your website to improve your results. In SEO, details do count - And,
                        we do it all for you.
                    </p>
                </>
            </ContetImageSection>
            <SeoServices></SeoServices>
            <HireProcess
                white={true}
                bg="bg-primary"
                pageTitle="Hire SEO Expert To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using SEO."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For SEO Services?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best SEO Expert"
                desc="Select from different engagement models to hire an SEO Expert for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
